export const GAMES = [
  {
    id: "space-invaders",
    title: "Space Invaders",
    emoji: "👾",
    tagline: "Canvas + loop + colisiones",
    controls: "← → mover | Espacio disparar | P pausa | R reiniciar",
  },
  {
    id: "cannon-trainer",
    title: "Cannon Trainer",
    emoji: "🎯",
    tagline: "Inputs → lógica → feedback → historial",
    controls: "Enter o botón DISPARAR",
  },
  {
    id: "pong",
    title: "Pong",
    emoji: "🏓",
    tagline: "Canvas + movimiento + rebotes",
    controls: "W/S jugador 1 | ↑/↓ jugador 2 | Espacio iniciar",
  },
  {
    id: "breakout",
    title: "Breakout",
    emoji: "🧱",
    tagline: "Canvas + bloques + vidas",
    controls: "← → mover | Espacio iniciar | P pausar",
  },
  {
    id: "chacalon-chat",
    title: "Conversando con Chacalón Virtual",
    emoji: "🎙️",
    tagline: "React + API + personaje conversacional",
    controls: "Escribe tu mensaje | Enter enviar | Shift + Enter nueva línea",
  },
];
